<template>
  <div>
    <div class="text-right">
      <div class="box">
        <!-- <img style="width: 100%; height: 100%; display:flex;flex-direction:column;" src="./img/bg.jpg" alt=""> -->
        <div style="width: 100%;padding: 0.89rem 0 0.96rem 0">
          <img style="margin-left: 0.41rem;" :style="$i18n.locale=='tc'||$i18n.locale=='zh'?'width: 80%;':'width: 85%;'" :src="img.title" alt="">
        </div>

        <div class="inviteNowbox">
          <!-- <img class="inviteNow" src="./img/InviteNow.png" alt=""> -->
          <div class="downloadNowbox">
            <img class="icon" src="../../assets/download/icon.png" alt="">
          </div>
          <!-- <div class="inviteNows">Download</div> -->
          <div class="downloadNowbox">
            <img @click="download" class="downloadNow" :src="img.downloadNow" alt="">
          </div>
        </div>
        <div style="margin: 0.6rem 0.7rem 0;">
          <img class="exhibitimg" :src="img.exhibitimg" alt="">
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {
  },
  data() {
    return {
      img: {
        title: require('../../assets/download/titleen.png'),
        downloadNow: require('../../assets/download/downloadNowen.png'),
        exhibitimg: require('../../assets/download/exhibitimgen.png'),
      },
      isIos: null,
      isAndroid: null,
      isIosUrl: 'https://apps.apple.com/cn/app/id1523009207',
      isAndroidUrl: 'https://play.google.com/store/apps/details?id=com.sy.pocket',
    };
  },
  created() {
    var u = navigator.userAgent;
    var isIos = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
    this.isIos = isIos
    this.isAndroid = isAndroid

    let payment_url = location.hash
    let askIndex = payment_url.indexOf('?');
    var newStr = payment_url.slice(askIndex);
    var theRequest = new Object();
    if (newStr.indexOf('?') != -1) {
      var str = newStr.substr(1);
      let strs = str.split('&');
      for (var i = 0; i < strs.length; i++) {
        theRequest[strs[i].split('=')[0]] = strs[i].split('=')[1];
      }
    }
    // this.$completes.loadErudaJs()
    let langs = theRequest.langType.substring(0, 2)
    let lang = theRequest.langType
    if (langs == 'zh') {
      if (lang == 'zh_TW' || lang == 'zh_HK') {
        this.$i18n.locale = 'tc'
        this.img = {
          title: require('../../assets/download/titletc.png'),
          downloadNow: require('../../assets/download/downloadNowtc.png'),
          exhibitimg: require('../../assets/download/exhibitimgzh.png'),
        }
      }
      else{
        this.$i18n.locale = 'zh'
        this.img = {
          title: require('../../assets/download/titlezh.png'),
          downloadNow: require('../../assets/download/downloadNowzh.png'),
          exhibitimg: require('../../assets/download/exhibitimgzh.png'),
        }
      }
    }
    else if (langs == 'ar') {
      this.$i18n.locale = 'ar'
      this.img = {
        title: require('../../assets/download/titlear.png'),
        downloadNow: require('../../assets/download/downloadNowar.png'),
        exhibitimg: require('../../assets/download/exhibitimgar.png'),
      }
    }
    else {
      this.$i18n.locale = 'en'
      this.img = {
        title: require('../../assets/download/titleen.png'),
        downloadNow: require('../../assets/download/downloadNowen.png'),
        exhibitimg: require('../../assets/download/exhibitimgen.png'),
      }
    }

    document.querySelector('html').setAttribute('lang', this.$i18n.locale);
    document.title = 'Pocket'
  },
  mounted() {

  },
  methods: {
    download() {
      if (this.isAndroid) {
        window.location.href = this.isAndroidUrl
      } else if (this.isIos) {
        window.location.href = this.isIosUrl
      }
    }
  },
};

</script>

<style>
* {
  margin: 0;
  padding: 0;
}

.text-right {
  background-image: url("../../assets/download/bg.jpg");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  background-clip: content-box;
}

.titleimg {
  /* padding: 0.89rem 0 0.96rem 0.41rem; */
  /* width: 100%; */
  height: 1.52rem;
  display: flex;
  flex-direction: column;
}

.inviteNowbox {
  left: 0;
  right: 0;
  margin: auto;
  display: flex;
  flex-direction: column;
}

.downloadNowbox {
  line-height: 1;
  display: flex;
  justify-content: center;
}

.icon {
  /* width: 1.05rem; */
  height: 1.45rem;
  margin-bottom: 0.35rem;
  display: flex;
  flex-direction: column;
}

.downloadNow {
  /* width: 2.4rem; */
  height: 0.74rem;
  display: flex;
  flex-direction: column;
}

.exhibitimg {
  width: 100%;
  display: flex;
  flex-direction: column;
}
</style>